/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type FilterType = "date" | "number" | "text" | "%future added value";
export type OperatorType = "AND" | "OR" | "%future added value";
export type Filter = {|
  name: string,
  filterType: FilterType,
  operator: OperatorType,
  denySelection?: ?boolean,
  conditions: $ReadOnlyArray<?Condition>,
|};
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQueryVariables = {|
  companyId: string,
  filters?: ?$ReadOnlyArray<?Filter>,
|};
export type Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQueryResponse = {|
  +Me: ?{|
    +id: string,
    +Company: ?{|
      +data: ?number
    |},
  |}
|};
export type Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery = {|
  variables: Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQueryVariables,
  response: Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQueryResponse,
|};
*/


/*
query Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery(
  $companyId: ID!
  $filters: [Filter]
) {
  Me {
    id
    Company(id: $companyId) {
      data: countUsageUnits(options: {filters: $filters}, context: RecentRegularAppointment)
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v3 = {
  "alias": "data",
  "args": [
    {
      "kind": "Literal",
      "name": "context",
      "value": "RecentRegularAppointment"
    },
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countUsageUnits",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f489f55912621a6157813c4f3aadccad",
    "id": null,
    "metadata": {},
    "name": "Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery",
    "operationKind": "query",
    "text": "query Filter5NoEntryIntoTheUsageUnitWithoutEquipmentCountQuery(\n  $companyId: ID!\n  $filters: [Filter]\n) {\n  Me {\n    id\n    Company(id: $companyId) {\n      data: countUsageUnits(options: {filters: $filters}, context: RecentRegularAppointment)\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b524325c8bc80b57e37902b8ee0a034e';

module.exports = node;
